import React, { useEffect } from 'react';
import ReactPopup from 'reactjs-popup';
import styles from './style.css';

const Popup = ({ children, ...props }) => {
    useEffect(() => {
        document.body.classList.add('popup-open');
        return () => document.body.classList.remove('popup-open');
    });

    return (
        <ReactPopup {...props}>
            <div id={props.popupID} data-metrics-location="PU">
                {children}
            </div>
            <style jsx>{styles}</style>
        </ReactPopup>
    );
};

export default Popup;



// WEBPACK FOOTER //
// ./src/components/Popup/Popup.js